// extracted by mini-css-extract-plugin
module.exports = {"titleWrap":"header_titleWrap__AJ6yU"};